import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

export default function MetricCard({ icon, label, value, valueColor = "text.primary" }) {
  return (
    <Card
      sx={{
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
        boxShadow: 0,
      }}
    >
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          {icon}
          <Typography variant="subtitle2" color="text.secondary">
            {label}
          </Typography>
        </Box>
        <Typography variant="h5" fontWeight="bold" sx={{ color: valueColor }}>
          {value}
        </Typography>
      </CardContent>
    </Card>
  );
}
